import React, {
    PureComponent
  }                             from 'react';
import PropTypes              from 'prop-types';
import {
  AnimatedView,
  StatsCard,
  StatsTable,
  ScoreCard,
  StatsGraph,
  EarningGraph,
  Notifications,
  WorkProgress,
  TwitterFeed,
  TodoListDemo,
  TeamMatesDemo
}                         from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';
import {Link}                 from 'react-router-dom';
import DatePicker from 'react-datepicker';
import ExpenseRecords from '../expenseRecords';

class AddExpense extends PureComponent{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            passed_venue: this.props.venue ? this.props.venue : '',
            payment_modes:[],
            venues: [],
            categories:[],
            sub_categories:[],
            selected_category:70,
            selected_subcategory:0,
            venue:this.props.venue ? this.props.venue : '',
            bill_no:'',
            name:'',
            mode:0,
            amount:'',
            description:'',
            bill_no:'',
            show_list: false,
            selected_date: moment(),
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getExpenseDetails = this.getExpenseDetails.bind(this);
        this.handlebutton = this.handlebutton.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.getVenuesForBuddy = this.getVenuesForBuddy.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    
    componentDidMount() {
         const {
          actions: {
            fetchStatsTableDataIfNeeded,
            fetchScoreCardDataIfNeeded,
          }
        } = this.props;

        console.log(this.state);
        console.log('this.props')
        console.log(this.props)

        this.getVenuesForBuddy();
        this.getExpenseDetails();

        
    }

    handleDate(date){
      this.setState({selected_date:date});
      console.log(this.state.selected_date)
    }

    getExpenseDetails() {
        const url = `${getLocationOrigin()}/cm/get_details_for_expenses/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {

            this.setState(
            { 
                payment_modes:data.payment_modes,
                categories:data.category,
                sub_categories:data.sub_category
            });
            console.log(this.state)
    
           })
          .catch(error => error);
    }

    getVenuesForBuddy(){
        const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            { 
                
                venues:data.result,
                venue : this.props.venue ? this.props.venue : data.result[0].id,
                
            });
    
           })
          .catch(error => error);
    }

    postResponse() {

        const new_date = moment(this.state.selected_date).format("YYYY-MM-DD")
        const url = `${getLocationOrigin()}/cm/save_details_for_expenses/`;
        const options = {...defaultOptions};
        
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'selected_date': new_date,
                            'venue':this.state.venue,
                            'name':this.state.name,
                            'amount':this.state.amount,
                            'mode':this.state.mode,
                            'bill_no':this.state.bill_no,
                            'description':this.state.description,
                            'category':this.state.selected_category,
                            'subcategory':this.state.selected_subcategory

                          });

        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){       
              console.log(response.Message)
              console.log('success')                           
              alert(response.Message);
              window.location.reload();
              })
          .catch(error => {
            console.log('error')
            console.log(error);
            alert(error.Message);
          });

    
    }

    handlebutton(){
        var new_val = {'name':'','amount':'','description':''};
        this.state.particulars.push(new_val);
    }

    handleChange(event) {
        const new_val = event.target;
        const name = new_val.name;
        console.log(new_val.value)
        if(name == 'venue'){
            this.setState({ venue:new_val.value})
        }
        else if(name == 'particular_name'){
            this.setState({name:new_val.value})
        }
        else if (name == 'category'){
            this.setState({selected_category:new_val.value})
        }
        else if(name == 'subcategory'){
            this.setState({selected_subcategory:new_val.value})
        }
        else if(name == 'mode'){
            this.setState({mode:new_val.value})
        }
        else if(name == 'amount'){
            this.setState({amount:new_val.value})
        }
        else if(name == 'Bill'){
            this.setState({bill_no:new_val.value})
        }
        else if(name == 'Description'){
            this.setState({description:new_val.value})
        }
    }

    handleSubmit(){
        event.preventDefault();
        console.log('post');
        this.postResponse();
        
    }

    handleClick(event){
        this.setState({show_list:true})
    }

    render(){
        console.log('render')
        console.log(this.props)
        console.log(this.state)
       const {
          statsTable,
          scoreCard
        } = this.props;

        const {
              actions: {
                fetchStatsTableDataIfNeeded,
                fetchScoreCardDataIfNeeded,
              }
            } = this.props;
        return(
          <div>
            { this.props.from_partner_tab &&
            <div className='col-md-12'>
                <Link to={`../crud/ExpenseRecords/${this.state.venue}`}>
                    <button className='button1' style={{float:'right'}} onClick={this.handleClick}> View Expenses </button>
                </Link>
            </div>
            }
            <div className="row col-md-12" style={styles.container}>
              <div className="row col-md-8 table-bordered" style={styles.table}>
                  <div style={styles.main_header} className='col-md-12 label_blue_1'>
                      Expenses
                  </div>
                  <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Venue
                        </div>
                        <select name="venue" className="col-md-6" style={styles.item_body} value={this.props.venue ? this.props.venue : this.state.venue}
                           onChange={this.handleChange} disabled={this.props.venue ? 'disabled' : ''} >
                            {
                               this.state.venues.map((venue, index) => (
                                  <option key={venue.id} value={venue.id}>{venue.name}</option>
                                ))
                             }
                         </select>
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Applicable Date
                          </div>
                          <DatePicker selected={this.state.selected_date} onChange={this.handleDate}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Name *
                          </div>
                          <input className="col-md-6" type= "text" name="particular_name" placeholder="Name of particular" onChange={this.handleChange}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Category
                          </div>
                          <select name="category" className="col-md-6" style={styles.item_body} value={this.state.selected_category}
                           onChange={this.handleChange}>
                            {
                                  Object.keys(this.state.categories).map((category, index) => (
                                  <option key={category} value={category}>{this.state.categories[category]}</option>
                                ))
                              }
                         </select>
                           
                      </div>

                      {this.state.selected_category == 10 &&
                          <div className="col-md-12" style={styles.items}>
                              <div className="col-md-6" style={styles.item_header}> 
                                  Sub Category
                              </div>
                                  
                              <select name="subcategory" className="col-md-6" style={styles.item_body} value={this.state.selected_subcategory}
                                  onChange={this.handleChange}>
                              {
                                  Object.keys(this.state.sub_categories).map((category, index) => (
                                  <option key={category} value={category}>{this.state.sub_categories[category]}</option>
                                ))
                              }
                              </select>
                              
                          </div>

                      }

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Mode Of Payment
                          </div>
                          <select name="mode" className="col-md-6" style={styles.item_body} value={this.state.mode}
                           onChange={this.handleChange}>
                            {
                                  Object.keys(this.state.payment_modes).map((category, index) => (
                                  <option key={category} value={category}>{this.state.payment_modes[category]}</option>
                                ))
                              }
                         </select>      
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Amount *
                          </div>
                          <input className="col-md-6" type= "number" name="amount" placeholder="enter the amount"  onChange={this.handleChange}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Bill No.
                          </div>
                          <input className="col-md-6" name="Bill" type= "text" placeholder="Bill no."  onChange={this.handleChange}/>
                           
                      </div>

                      <div style={styles.items} className="col-md-12">

                          <div style={styles.item_header} className="col-md-6">
                              Description *
                          </div>
                          <textarea className="col-md-6" rows="3" cols="20" name="Description" type= "text" placeholder="Description for this Expense" onChange={this.handleChange}/>
                           
                      </div>

                      <div style={{ padding:'1%', marginLeft:'10px'}}>
                          <div style={styles.button_submit} className="col-md-12">
                            <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit}/>
                          </div>
                      </div>

                  </form>
              </div>
            </div>      
          </div>
        );
    }
}

export default AddExpense;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addExpense/addExpense.js